export type GTMEvent = Record<string, unknown>;

export type GTMAnalyticsContext = {
  app_build_id: string;
  traffic_type: 'internal' | null;
  debug_mode: true | null;
};

// Context is queued before the Google tag initializes. No identity or consent state is changed.
export const GTM_ANALYTICS_CONTEXT_SCRIPT = `(function(w){
var q=new URLSearchParams(w.location.search||'');
var internal=/^(localhost|127\\.0\\.0\\.1|\\[?::1\\]?)$/.test(w.location.hostname)||/^diagnostic[-_]/i.test(q.get('utm_campaign')||'');
w.atrivialAnalyticsContext={app_build_id:${JSON.stringify(import.meta.env.VITE_APP_BUILD_ID ?? 'unknown')},traffic_type:internal?'internal':null,debug_mode:internal?true:null};
w.dataLayer=w.dataLayer||[];w.dataLayer.push(w.atrivialAnalyticsContext);
})(window);`;

export const GTM_CONTAINER_ID = 'GTM-MSP2HKJ7';

export const GTM_HEAD_SCRIPT = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_CONTAINER_ID}');`;

export const GTM_NOSCRIPT_SRC = `https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}`;

export function queueGTMEvent(event: GTMEvent): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...event,
    ...(window.atrivialAnalyticsContext ?? {
      app_build_id: import.meta.env.VITE_APP_BUILD_ID ?? 'unknown',
      traffic_type: null,
      debug_mode: null,
    }),
  });
}

declare global {
  interface Window {
    dataLayer?: GTMEvent[];
    atrivialAnalyticsContext?: GTMAnalyticsContext;
  }
}
